import http from "@/http/axios";
import { appModule } from "@/store/modules/app";
import { has_value } from "@/utils/app-util";

export async function getPatientSleepByUuid(LifeStyleOption){
    const url = (has_value(LifeStyleOption.date) && has_value(LifeStyleOption.end_date))? `/user/${LifeStyleOption.uuid}/record/sleep/v2?date=${LifeStyleOption.date}&end_date=${LifeStyleOption.end_date}`
                :(has_value(LifeStyleOption.date)) ? `/user/${LifeStyleOption.uuid}/record/sleep/v2?date=${LifeStyleOption.date}`
                :(has_value(LifeStyleOption.end_date)) ? `/user/${LifeStyleOption.uuid}/record/sleep/v2?end_date=${LifeStyleOption.end_date}`
                : `/user/${LifeStyleOption.uuid}/record/sleep/v2`;
    const result = await http.get(url);
    if (result) {
        if (result.data.status === "Success") {
          return result.data.data.records;
        } else {
          appModule.sendErrorNotice("取得圖表失敗");
        }
      } else {
        appModule.sendErrorNotice("取得圖表失敗");
      }
}

export async function getPatientStepByUuid(LifeStyleOption){
    const url = (has_value(LifeStyleOption.date) && has_value(LifeStyleOption.end_date))? `/user/${LifeStyleOption.uuid}/record?only=lifestyle:step&limit=-1&order=asc&start_from=${LifeStyleOption.date}&end_to=${LifeStyleOption.end_date}`
                :(has_value(LifeStyleOption.date)) ? `/user/${LifeStyleOption.uuid}/record?only=lifestyle:step&limit=-1&order=asc&start_from=${LifeStyleOption.date}`
                :(has_value(LifeStyleOption.end_date)) ? `/user/${LifeStyleOption.uuid}/record?only=lifestyle:step&limit=-1&order=asc&end_to=${LifeStyleOption.end_date}`
                : `/user/${LifeStyleOption.uuid}/record?only=lifestyle:step&limit=-1&order=asc`;
    const result = await http.get(url);
    if (result) {
        if (result.data.status === "Success") {
            return result.data.data.records;
        } else {
            appModule.sendErrorNotice("取得圖表失敗");
        }
        } else {
        appModule.sendErrorNotice("取得圖表失敗");
        }
}

export async function getPatientStepGroupByHourByUuid(LifeStyleOption){
    const url = (has_value(LifeStyleOption.date) && has_value(LifeStyleOption.end_date))? `/user/${LifeStyleOption.uuid}/record/step/hour/summary?date=${LifeStyleOption.date}&end_date=${LifeStyleOption.end_date}`
                :(has_value(LifeStyleOption.date)) ? `/user/${LifeStyleOption.uuid}/record/step/hour/summary?date=${LifeStyleOption.date}`
                :(has_value(LifeStyleOption.end_date)) ? `/user/${LifeStyleOption.uuid}/record/step/hour/summary?end_date=${LifeStyleOption.end_date}`
                : `/user/${LifeStyleOption.uuid}/record/step/hour/summary`;
    const result = await http.get(url);
    if (result) {
        if (result.data.status === "Success") {
            return result.data.data.records;
        } else {
            appModule.sendErrorNotice("取得圖表失敗");
        }
        } else {
        appModule.sendErrorNotice("取得圖表失敗");
        }
}

export async function getPatientStepGroupBydateByUuid(LifeStyleOption){
    const url = (has_value(LifeStyleOption.date) && has_value(LifeStyleOption.end_date))? `/user/${LifeStyleOption.uuid}/record/step/date/summary?date=${LifeStyleOption.date}&end_date=${LifeStyleOption.end_date}`
                :(has_value(LifeStyleOption.date)) ? `/user/${LifeStyleOption.uuid}/record/step/date/summary?date=${LifeStyleOption.date}`
                :(has_value(LifeStyleOption.end_date)) ? `/user/${LifeStyleOption.uuid}/record/step/date/summary?end_date=${LifeStyleOption.end_date}`
                : `/user/${LifeStyleOption.uuid}/record/step/date/summary`;
    const result = await http.get(url);
    if (result) {
        if (result.data.status === "Success") {
          return result.data.data.records;
        } else {
          appModule.sendErrorNotice("取得圖表失敗");
        }
      } else {
        appModule.sendErrorNotice("取得圖表失敗");
      }
}